import request from './request';

export const getClaims = () =>
    request({
        url: "/user/claims",
        method: "get"
    });
